// extracted by mini-css-extract-plugin
module.exports = {"feedbackBoxLoader":"SupportTicket_feedbackBoxLoader__P8KrY","messages":"SupportTicket_messages__35BKn"};